const userInfo = () => import(/* webpackChunkName: "user" */ '@/views/page/user/index.vue');
const fans = () => import(/* webpackChunkName: "user" */ '@/views/page/user/fans.vue');
const like = () => import(/* webpackChunkName: "user" */ '@/views/page/user/like.vue');
const report = () => import(/* webpackChunkName: "user" */ '@/views/page/user/report.vue');

const userRoute = [
    {
        path: '/userInfo',
        name: 'userInfo',
        component: userInfo,
     
    },
    {
        path: '/user/fans',
        name: 'fans',
        component: fans 
    },
    {
        path: '/user/like',
        name: 'like',
        component: like 
    },
    {
        path: '/user/report',
        name: 'userReport',
        component: report 
    },
    

]

export default userRoute
